<!--
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-12-01 20:57:00
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-12-13 10:49:25
-->
<template>
  <el-dialog
    ref="elDialog"
    v-dialogDrag
    :title="
      operType === 'edit'
        ? $t('org.editOrg')
        : operType === 'add'
          ? $t('org.createOrg')
          : operType === 'details'
            ? $t('org.details')
            : $t('org.createOrg')
    "
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    custom-class="self-dialog-form"
    width="50%"
  >
    <div class="custom-theme">
      <el-form
        ref="formInfo"
        :model="formInfo"
        :rules="rules"
        label-position="top"
        :hide-required-asterisk="hideStar"
        class="demo-formInfo clearfix custom-theme"
      >
        <el-row :gutter="24">
          <!-- 部门名称 -->
          <el-col :span="12">
            <el-form-item :label="$t('org.orgName')" prop="orgName">
              <el-input
                v-model="formInfo.orgName"
                :disabled="operType === 'details'"
                :placeholder="operType !== 'details' ? $t('common.pleaseEnter') : ''"
                maxlength="64"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 上级部门 -->
          <el-col :span="12">
            <el-form-item :label="$t('org.parentOrg')" prop="parentName">
              <el-select
                v-model="formInfo.parentName"
                :placeholder="operType !== 'details' ? $t('common.pleaseChoose') : ''"
                multiple
                collapse-tags
                disabled
                style="width: 100%"
                @change="selectChange"
              >
                <el-input
                  v-model="filterText"
                  placeholder="输入名称"
                  style="width: 90%; margin-left: 16px; margin-top: 8px"
                ></el-input>
                <el-option style="width: 100%; height: auto" :value="selectData">
                  <el-tree
                    ref="tree"
                    :data="orgTree"
                    show-checkbox
                    node-key="id"
                    default-expand-all
                    class="self-tree"
                    :props="defaultProps"
                    :check-strictly="true"
                    :filter-node-method="filterNode"
                    @check-change="handleCheckChange"
                  >
                    <span slot-scope="{ node }" :title="node.label" class="self-custom-tree">
                      <span>{{ node.label }}</span>
                    </span>
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- 部门编码 -->
          <el-col :span="12">
            <el-form-item :label="$t('org.orgCode')" prop="orgCode">
              <el-input
                v-model="formInfo.orgCode"
                :disabled="operType === 'details'"
                :placeholder="operType !== 'details' ? $t('common.pleaseEnter') : ''"
                maxlength="64"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 排序 -->
          <el-col :span="12">
            <el-form-item :label="$t('user.sort')" prop="sort">
              <el-input-number
                v-model="formInfo.sort"
                :disabled="operType === 'details'"
                :precision="0"
                controls-position="right"
                :min="0"
                :placeholder="operType !== 'details' ? $t('org.pleaseEnterSort') : ''"
                max-length="10"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- 部门简称 -->
          <el-col :span="12">
            <el-form-item :label="$t('org.orgShortName')" prop="orgShortName">
              <el-input
                v-model="formInfo.orgShortName"
                :disabled="operType === 'details'"
                :placeholder="operType !== 'details' ? $t('common.pleaseEnter') : ''"
                maxlength="64"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 是否有效 -->
          <el-col :span="12">
            <el-form-item :label="$t('org.isEffect')" prop="effect">
              <el-radio-group
                ref="radioGroup"
                v-model="formInfo.effect"
                :disabled="operType === 'details'"
              >
                <el-radio :label="true">有效</el-radio>
                <el-radio :label="false">无效</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- 地点 -->
          <el-col :span="12">
            <el-form-item :label="$t('org.address')" prop="address">
              <el-input
                v-model="formInfo.address"
                :disabled="operType === 'details'"
                type="textarea"
                :rows="4"
                :placeholder="
                  operType !== 'details'
                    ? `${$t('org.pleaseEnterContent')
                    }(${
                      $t('common.wordCountLimit', [$getInputMaxLimitConst('limit100')])
                    })`
                    : ''
                "
                :maxlength="$getInputMaxLimitConst('limit100')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 描述 -->
          <el-col :span="12">
            <el-form-item :label="$t('org.remarks')" prop="remark">
              <el-input
                v-model="formInfo.remark"
                :disabled="operType === 'details'"
                type="textarea"
                :rows="4"
                :placeholder="
                  operType !== 'details'
                    ? `${$t('org.pleaseEnterContent')
                    }(${
                      $t('common.wordCountLimit', [$getInputMaxLimitConst('limit100')])
                    })`
                    : ''
                "
                :maxlength="$getInputMaxLimitConst('limit100')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="operType === 'details'" type="primary" @click="closeModel">
        {{ $t("common.closeTxt") }}
      </el-button>
      <el-button v-if="operType !== 'details'" plain @click="closeModel">
        {{ $t("public.cancel") }}
      </el-button>
      <el-button
        v-if="operType !== 'details'"
        :loading="infoLoading"
        type="primary"
        @click="submitForm('formInfo')"
      >
        {{ $t("public.confirm") }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import orgApi from "@/api/org/org";
import { mapGetters } from "vuex";
import { commonFilterNode } from "@/utils";

export default {
  name: "UserNewInfo",
  components: {},

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    propData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    operType() {
      return this.propData.pageType;
    },
    ...mapGetters(["tenantId"])
  },
  data() {
    return {
      // start 设备编码
      endTimeHolder: this.$t("common.pleaseChoose"),
      shutdownDurationHolder: this.$t("common.pleaseEnter"),
      equipmentData: [],
      equipmentLoading: false,
      personnelData: [],
      personnelLoading: false,
      // end
      disabled: false,
      infoLoading: false,
      formInfo: {},
      rules: {
        // 部门名称
        orgName: [
          {
            required: true,
            message: `${this.$t("common.pleaseEnter")}${this.$t("org.orgName")}`,
            trigger: ["blur"]
          }
        ],
        // 部门编码
        orgCode: [
          {
            required: true,
            message: `${this.$t("common.pleaseEnter")}${this.$t("org.orgCode")}`,
            trigger: ["blur"]
          }
        ],
        // 上级部门
        parentName: [
          {
            required: true,
            message: `${this.$t("common.pleaseChoose")}${this.$t("org.parentOrg")}`,
            trigger: ["blur"]
          }
        ]
      },
      sourceOptions: [],
      runStatusOptions: [],
      // 创建时设备是有未完成记录
      hasEquip: false,
      afterSupply: false,
      orgData: [],
      selectData: [], // 下拉框中的选项数据
      orgTree: [],
      filterText: "",
      parentName: [],
      defaultProps: {
        children: "children",
        label: "orgName"
      },
      hideStar: false
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.getOrgTree();

    /*
     * 获取组织数据，为了回显组织信息
     * 查看|编辑时获取详情
     */
    this.orgTree = this.propData.orgTree;
    if (this.operType !== "add") {
      this.getDetailsById(this.propData.id);
      if (this.operType === "details") {
        this.hideStar = true;
      }
    } else {
      // 新增时将组织赋值上去
      this.formInfo.effect = true;
      this.formInfo.sort = "0";
      this.parentId = this.propData.parentId;
      this.parentName = this.propData.parentName;
      if (this.propData.parentId) {
        if (this.parentId && this.parentId.length > 0) {
          this.formInfo.parentId = this.parentId;
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(this.parentId);
          });
        }
        if (this.parentName && this.parentName.length > 0) {
          this.formInfo.parentName = this.parentName;
        }
      }
    }
  },
  methods: {
    // 单选树型结构选项框被点击发生改变
    handleCheckChange(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([data]);
        const arrLabel = [];
        const arr = [];
        const arrIds = [];
        if ([data] && [data].length > 0) {
          [data].forEach((item, index) => {
            arrLabel.push(item.orgName);
            arr.push(item);
            arrIds.push(item.id);
          });
          this.formInfo.parentName = arrLabel; // select
          this.formInfo.parentId = arrIds;
          this.selectData = arr; // option
        }
      }
    },

    /*
     * 树型结构选项框被点击发生改变
     * handleCheckChange() {
     *   const checkeArr = this.$refs.tree.getCheckedNodes();
     *   //通过id获取名称
     *   const arrLabel = [];
     *   const arr = [];
     *   const arrIds = [];
     *   if (checkeArr && checkeArr.length > 0) {
     *     checkeArr.forEach((item, index) => {
     *       arrLabel.push(item.orgName);
     *       arr.push(item);
     *       arrIds.push(item.id);
     *     });
     *     this.formInfo.parentName = arrLabel; //select
     *     this.formInfo.parentId = arrIds;
     *     this.selectData = arr; // option
     *   }
     * },
     */
    /**
     * @description: 筛选组织树
     * @param {*}
     * @return {*}
     */
    // 筛选组织树
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    // 下拉框中的数据发生改变
    selectChange(data) {
      const arrNew = [];
      const orgLength = this.orgTree.length;
      const dataLength = data.length;
      for (let i = 0; i < orgLength; i++) {
        for (let j = 0; j < dataLength; j++) {
          if (data[j] === this.orgTree[i].id) {
            arrNew.push(this.orgTree[i]);
          }
        }
      }
      this.$refs.tree.setCheckedNodes(arrNew); // 设置勾选的值
    },
    getDetailsById(id) {
      orgApi.getDetailsById(id).then(res => {
        if (res.success) {
          this.formInfo = { ...res.data };
          console.log(this.formInfo);
          if (this.formInfo.parentId) {
            // if (this.parentId && this.parentId.length > 0) {
            this.formInfo.parentId = [res.data.parentId];
            this.formInfo.parentName = [res.data.parentName];
            this.$nextTick(() => {
              this.$refs.tree.setCheckedKeys(this.formInfo.parentId);
            });

            /*
             * }
             * if (this.parentName && this.parentName.length > 0) {
             *   this.formInfo.parentName = this.parentName;
             * }
             */
          }
        }
      });
    },
    // 获取组织列表
    getOrgTree() {
      orgApi.getCascadeOrgList(this.tenantId).then(res => {
        const { data } = res || {};
        if (data && data.length !== 0) {
          this.orgData = data;
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.infoLoading = true;
          if (this.formInfo.id) {
            // 编辑
            this.editForm();
          } else {
            // 新增
            this.addForm();
          }
        } else {
          return false;
        }
      });
    },
    closeModel() {
      this.dialogVisible = false;
    },
    editForm() {
      const addData = { ...this.formInfo };
      addData.parentId = this.formInfo.parentId[0];
      addData.parentName = this.formInfo.parentName[0];
      orgApi
        .editOrg(addData)
        .then(res => {
          this.infoLoading = false;
          this.$message.closeAll();
          this.$message.success(this.$t("common.editSuccess"));
          this.dialogVisible = false;
          this.$emit("success");
        })
        .catch(() => {
          this.infoLoading = false;
        });
    },
    addForm() {
      const addData = { ...this.formInfo };
      addData.parentId = this.formInfo.parentId[0];
      addData.parentName = this.formInfo.parentName[0];
      orgApi
        .addOrg(addData)
        .then(res => {
          this.infoLoading = false;
          this.$message.closeAll();
          this.$message.success(this.$t("common.addSuccess"));
          this.dialogVisible = false;
          this.$emit("success");
        })
        .catch(() => {
          this.infoLoading = false;
        });
    }
  }
};
</script>

<style scoped lang='scss'>
</style>
